import { useAuth0 } from '@auth0/auth0-react';
import { ThemeProvider } from '@material-ui/core';
import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes } from 'react-router-dom';
import GlobalStyles from 'src/components/GlobalStyles';
import routes from 'src/routes';
import theme from 'src/theme';
import Loader from './components/Loader';

const App = () => {
  const routing = useRoutes(routes());
  const { isLoading } = useAuth0();

  // console.log(user);
  // if (user && _.includes(user[`${process.env.REACT_APP_SERVER_URL}/roles`], 'Admin'))
  // console.log("I am an admin");

  if (isLoading) {
    return (
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Loader />
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      {routing}
    </ThemeProvider>
  );
};

export default App;
